export default 
{
	"Account": "アカウント",
	"AreYouSureYouWantToDiscardYourChanges": "変更を破棄してもよろしいですか？",
	"BillingAddress": "請求先住所",
	"Cancel": "キャンセル",
	"CardExpired": "期限切れ",
	"CardExpiresSoon": "まもなく期限切れ",
	"Close": "閉じる",
	"CloseSidebar": "サイドバーを閉じる",
	"CloseThisDialogToRenewYourSessionAndContinue": "このダイアログを閉じてセッションを更新し、続行してください。",
	"CodeAuthenticated": "コード認証済み",
	"ConsentMessageBoth": "{orgName}が提供する{termsOfService}と{privacyPolicy}に同意します。",
	"ConsentMessagePrivacyOnly": "{orgName}が提供する{privacyPolicy}に同意します。",
	"ConsentMessageTermsOnly": "{orgName}が提供する{termsOfService}に同意します。",
	"ContinueButton": "続ける",
	"ContinueWithEmail": "メールで続行",
	"ContinueWithProvider": "{provider}で続行",
	"Created": "作成済み",
	"DefaultPortalMessageBody": "<p>ここに来てくれてうれしいです。</p><p>このポータルは、私たちと協力し、すべてを一か所で管理するためのあなた専用の空間です。開始するのに助けが必要なときは教えてください。</p><p>あなたと一緒に働けることを楽しみにしています！</p>",
	"DefaultPortalMessageHeader": "ようこそ！",
	"Delete": "削除",
	"DeleteCard": "カードを削除",
	"DeleteCardConfirmation": "このカードを削除してもよろしいですか？",
	"DeleteCardOnFile": "保存したカードを削除しますか？",
	"DeleteSavedCardFailed": "カードを削除できませんでした。もう一度お試しください。",
	"Dialog": "ダイアログ",
	"DiscardChanges": "変更を破棄",
	"DueDate": "期限",
	"EditProfile": "プロフィール編集",
	"Email": "メール",
	"EmailAddress": "メールアドレス",
	"EmailAddressIsRequired": "メールアドレスが必要です。",
	"EmailMustBeFormatted": "メールは name@domain.com の形式でなければなりません。",
	"EmailRequired": "メールアドレスが必要です",
	"EntryCreated": "エントリーが作成されました",
	"EntryStatus": "エントリーステータス",
	"EntrySubmitted": "エントリーが送信されました",
	"EntryUpdated": "エントリーが更新されました",
	"ErrorOccurred": "エラーが発生しました",
	"ExpirationDate": "有効期限",
	"GoodAfternoon": "こんにちは！",
	"GoodAfternoonWithName": "こんにちは、{name}！",
	"GoodEvening": "こんばんは！",
	"GoodEveningWithName": "こんばんは、{name}！",
	"GoodMorning": "おはようございます！",
	"GoodMorningWithName": "おはようございます、{name}！",
	"GroupTasksBy": "グループ化",
	"HighPriority": "1 - 高",
	"Homepage": "ホーム",
	"InactiveGuestError": "あなたは{orgName}のアクティブなゲストではありません。",
	"Incomplete": "未完了",
	"InvalidCode": "無効なコードです",
	"KeepEditing": "編集を続ける",
	"Later": "後で",
	"LoginAsUserToAccessEntry": "このエントリにアクセスするには{requiredUser}としてログインしてください。",
	"LoginAsUserToAccessOrg": "{orgName}にアクセスするには{requiredUser}としてログインしてください。",
	"LoginInstruction": "{orgName}にアクセスを続けてください。",
	"Logout": "ログアウト",
	"LowPriority": "3 - 低",
	"ManageSavedCards": "保存済みカードを管理",
	"MediumPriority": "2 - 中",
	"MyTasks": "マイタスク",
	"NameOnCard": "カード名義",
	"NextWeek": "来週",
	"NoAddressProvided": "住所が指定されていません",
	"NoNameProvided": "名前が指定されていません",
	"NoSavedCards": "保存済みのカードはありません。",
	"NoTasks": "タスクがありません。",
	"OpenInNewTab": "新しいタブで開く",
	"OpenSidebar": "サイドバーを開く",
	"Or": "または",
	"PastDue": "期限切れ",
	"PleaseSelectARegistrationForm": "登録フォームを選択してください。",
	"PoweredByCognito": "Cognito Forms を搭載しました",
	"Priority": "優先度",
	"PrivacyPolicy": "プライバシーポリシー",
	"PublicLink": "公開リンク",
	"RegistrationListHeader": "どのように登録しますか？",
	"SkipToFormList": "フォーム一覧にスキップ",
	"Status": "ステータス",
	"Submitted": "提出済み",
	"Tasks": "タスク",
	"TermsOfService": "利用規約",
	"ThisOrganization": "この組織",
	"ThisWeek": "今週",
	"Today": "今日",
	"Tomorrow": "明日",
	"Type": "タイプ",
	"Unprioritized": "未優先",
	"UnsavedChanges": "未保存の変更",
	"Unscheduled": "未定",
	"Updated": "更新済み",
	"Validating": "検証中",
	"VerificationInstruction": "続行するには、メールアドレスに送信されたコードを入力してください。",
	"VerificationResend": "コードを受け取っていませんか？今すぐ再送信してください。",
	"VerificationResending": "ただいま、新しいコードをお送りしています。",
	"VerificationTitle": "認証コード",
	"You": "あなた",
	"YouAreNotAMemberOf": "あなたは{orgName}のメンバーではありません。",
	"YouDoNotHaveAccessToFormName": "{formName}へのアクセス権がなくなりました。",
	"YouDoNotHaveAccessToThisForm": "このフォームにアクセスできません。",
	"YouMustAgree": "同意する必要があります。",
	"YourSessionIsAboutToExpire": "セッションの有効期限がまもなく切れます"
};
